function FormatYear(yearStart, yearEnd) {
    if (yearStart === yearEnd) {
        return yearStart
    }
    return yearStart + " - " + yearEnd
}


function validateAndOpenUrl(url, newWindow = false) {

    const allowlist = ['/', '/cdc', '/cdi', '/help', '/pophealth', '/dataportal', '/indicatordefinitions'];

    const validUrl = allowlist.filter(item => item === url);

    if (validUrl.length > 0) {
        if (window.location.href.indexOf("https://localhost") > -1 || window.location.href.indexOf("http://localhost") > -1) {

            let newUrl = "";
            if (validUrl[0] === "/") newUrl = '/';
            if (validUrl[0] === "/cdc") newUrl = 'https://wwwdev.cdc.gov'
            if (validUrl[0] === "/cdi") newUrl = 'https://wwwdev.cdc.gov/cdi'
            if (validUrl[0] === "/help") newUrl = 'https://wwwdev.cdc.gov/cdi/help-topics'
            if (validUrl[0] === "/pophealth") newUrl = 'https://wwwdev.cdc.gov/nccdphp/'
            if (validUrl[0] === "/dataportal") newUrl = 'https://data.cdc.gov/browse?category=Chronic+Disease+Indicators'
            if (validUrl[0] === "/indicatordefinitions") newUrl = 'https://wwwdev.cdc.gov/cdi/indicator-definitions/'

            if (newUrl !== "") {
                newWindow === true
                    ? window.open(newUrl)
                    : window.location.href = newUrl;
            }
        }
        else {
            newWindow === true
                ? window.open(validUrl[0])
                : window.location.href = validUrl[0];
        }
    }

};



export {
    FormatYear, validateAndOpenUrl
};